import { onMounted, reactive } from 'vue'
import { useRoute } from 'vue-router'
import { usePoliticalActions } from './usePoliticalActions'
// import { usePoliticalActionDialog } from './usePoliticalActionDialog'
import { useMemoryReject } from './useMemoryReject'
import { useNotifications } from '@/services/notification/useNotifications'
import { useDialog } from '@/services/useDialog'
import { useLogs } from '@/services/useLogs'
import { useTopData } from '@/services/useHome'
import { useLoader } from '../useLoader'
import { useError } from '../useError'
import axios from '@/axios'
import dayjs from 'dayjs'

const tabs = reactive([
  {
    name: '経費',
    required: true,
    status: 0,
    fields: ['memoryItems'],
  },
  { name: '事務局より', required: false, status: 0 },
])

export const useMemoryFormTabs = () => {
  return { tabs }
}

export const useMemoryForm = () => {
  const {
    currentPoliticalAction,
    getActivitiesAfterResponse,
  } = usePoliticalActions()
  const { getNotificationsAfterResponse } = useNotifications()
  const { getTimelineAfterResponse } = useLogs()
  const { getTopDataAfterResponse } = useTopData()
  // const { activityDialog } = usePoliticalActionDialog()
  const { toggleShowLoader } = useLoader()
  const { toggleShowError } = useError()
  const route = useRoute()

  onMounted(() => {
    // TODO
    // 1   ・・・青チェック
    // -1  ・・・バリデーションエラー
    // -10 ・・・差し戻しあり
    const status =
      currentPoliticalAction.memory.sentBackItems.length === 0 ? 0 : -10
    setTabStatus(0, status)
  })

  const setTabStatus = (tabIndex, status) => {
    tabs[tabIndex].status = status
  }

  const getSentBackItemMessage = attr => {
    const sentBackList = []
    if (
      currentPoliticalAction.memory.option.viewType === 0 ||
      currentPoliticalAction.memory.option.viewType === 1 ||
      currentPoliticalAction.memory.sentBackItems.length == 0
    ) {
      return []
    }
    currentPoliticalAction.memory.sentBackItems.forEach(item => {
      if (!item || item.length == 0) return []
      const backItem = item.items.find(item => item.target == attr)
      if (backItem !== undefined) {
        sentBackList.push(backItem)
      }
    })
    if (sentBackList.length > 0) {
      sentBackList
      return sentBackList
    }
    return []
  }

  const submitActivity = async (id, type) => {
    try {
      toggleShowLoader(true)
      // validate
      if (!(typeof id === 'number' && id > 0)) {
        throw new Error('invalid id: ' + id)
      }

      if (!(type === 'memory' || type === 'memory-apply')) {
        throw new Error('invalid type: ' + type)
      }

      // fileの送信を行うためformDataオブジェクトを使用する
      const formdata = new FormData()
      formdata.append('is_temporary', type === 'memory')
      formdata.append(
        'document_type',
        currentPoliticalAction.memory.documentType,
      )

      for (let i = 0; i < currentPoliticalAction.memory.expenses.length; i++) {
        // 項目種別のフォームデータを作成
        formdata.append(
          'memory[expenses][' + i + '][type]',
          currentPoliticalAction.memory.expenses[i].type[0].id,
        )

        // 宿泊費の場合、宿泊日数のフォームデータを作成
        if (
          currentPoliticalAction.memory.expenses[i].stayDays &&
          currentPoliticalAction.memory.expenses[i].type[0].id === 1
        ) {
          formdata.append(
            'memory[expenses][' + i + '][stay_days]',
            currentPoliticalAction.memory.expenses[i].stayDays,
          )
        }

        //idのフォームデータを作成
        if (currentPoliticalAction.memory.expenses[i].receipt?.id) {
          formdata.append(
            'memory[expenses][' + i + '][receipt][id]',
            currentPoliticalAction.memory.expenses[i].receipt.id,
          )
        }

        //支払年月日のフォームデータを作成
        formdata.append(
          'memory[expenses][' + i + '][receipt][expense_date]',
          currentPoliticalAction.memory.expenses[i].receipt.expenseDate === null
            ? ''
            : dayjs(
                currentPoliticalAction.memory.expenses[i].receipt.expenseDate,
              ).format('YYYY-MM-DD'),
        )

        // 経費項目のフォームデータを作成
        if (currentPoliticalAction.actionTypes.length === 1) {
          formdata.append(
            'memory[expenses][' + i + '][receipt][expense_type_id]',
            currentPoliticalAction.actionTypes[0].type,
          )
        }

        // 支払額のフォームデータを作成
        formdata.append(
          'memory[expenses][' + i + '][receipt][expense_amount]',
          currentPoliticalAction.memory.expenses[i].receipt.expenseAmount ===
            null
            ? ''
            : currentPoliticalAction.memory.expenses[i].receipt.expenseAmount,
        )

        // 支出内容のフォームデータを作成
        formdata.append(
          'memory[expenses][' + i + '][receipt][expense_content1]',
          currentPoliticalAction.memory.expenses[i].receipt.expenseContent1 ===
            null
            ? ''
            : currentPoliticalAction.memory.expenses[i].receipt.expenseContent1,
        )

        // 補記のフォームデータを作成
        if (currentPoliticalAction.memory.expenses[i].receipt.expenseContent2) {
          formdata.append(
            'memory[expenses][' + i + '][receipt][expense_content2]',
            currentPoliticalAction.memory.expenses[i].receipt
              .expenseContent2 === null
              ? ''
              : currentPoliticalAction.memory.expenses[i].receipt
                  .expenseContent2,
          )
        }

        // 債権者住所・氏名のフォームデータを作成
        if (currentPoliticalAction.memory.expenses[i].receipt.creditorInfo) {
          formdata.append(
            'memory[expenses][' + i + '][receipt][creditor_info]',
            currentPoliticalAction.memory.expenses[i].receipt.creditorInfo ===
              null
              ? ''
              : currentPoliticalAction.memory.expenses[i].receipt.creditorInfo,
          )
        }

        // 支払証明書フラグのフォームデータを作成
        formdata.append(
          'memory[expenses][' + i + '][receipt][have_receipt_images]',
          !currentPoliticalAction.memory.expenses[i].receipt.haveReceiptImages,
        )

        // 按分フラグのフォームデータを作成
        formdata.append(
          'memory[expenses][' + i + '][receipt][is_distributed]',
          currentPoliticalAction.memory.expenses[i].receipt.isDistributed,
        )

        // 按分分母のフォームデータを作成
        if (
          currentPoliticalAction.memory.expenses[i].receipt.isDistributed &&
          currentPoliticalAction.memory.expenses[i].receipt.numerator
        ) {
          formdata.append(
            'memory[expenses][' + i + '][receipt][numerator]',
            currentPoliticalAction.memory.expenses[i].receipt.numerator,
          )
        }

        //按分分子のフォームデータを作成
        if (
          currentPoliticalAction.memory.expenses[i].receipt.isDistributed &&
          currentPoliticalAction.memory.expenses[i].receipt.denominator
        ) {
          formdata.append(
            'memory[expenses][' + i + '][receipt][denominator]',
            currentPoliticalAction.memory.expenses[i].receipt.denominator,
          )
        }

        // 一部充当金額のフォームデータを作成
        if (
          currentPoliticalAction.memory.expenses[i].receipt.isPartial &&
          currentPoliticalAction.memory.expenses[i].receipt.partialAmount
        ) {
          formdata.append(
            'memory[expenses][' + i + '][receipt][partial_amount]',
            currentPoliticalAction.memory.expenses[i].receipt.partialAmount,
          )
        }
        // 一部充当内容のフォームデータを作成
        if (
          currentPoliticalAction.memory.expenses[i].receipt.isPartial &&
          currentPoliticalAction.memory.expenses[i].receipt.partialComment
        ) {
          formdata.append(
            'memory[expenses][' + i + '][receipt][partial_comment]',
            currentPoliticalAction.memory.expenses[i].receipt.partialComment,
          )
        }

        // 添付資料ののフォームデータを作成
        currentPoliticalAction.memory.expenses[i].additionalResources.forEach(
          file => {
            //登録済みのフォームデータを作成
            if (file?.display) {
              formdata.append(
                'memory[expenses][' + i + '][keep_file_names][]',
                file.display,
              )
            } else {
              // 新規登録のフォームデータを作成
              formdata.append(
                'memory[expenses][' + i + '][additional_resources][]',
                file,
              )
            }
          },
        )

        //画像のフォームデータを作成
        for (
          let index = 0;
          index < currentPoliticalAction.memory.expenses[i].image.length;
          index++
        ) {
          Object.keys(
            currentPoliticalAction.memory.expenses[i].image[index],
          ).forEach(key => {
            if (currentPoliticalAction.memory.expenses[i].image[index][key]) {
              const keyName =
                'memory[expenses][' +
                i +
                '][images][' +
                index +
                '][' +
                key +
                ']'
              formdata.append(
                keyName,
                currentPoliticalAction.memory.expenses[i].image[index][key],
              )
            }
          })
        }
      }

      // postだとだとマルチパート形式のファイル送信がうまくいかないためputをオーバーライド
      let config = {
        headers: {
          'content-type': 'multipart/form-data',
          'X-HTTP-Method-Override': 'PUT',
        },
      }
      const res = await axios.post(`/actions/${id}`, formdata, config)
      if (route.name === 'Activities') {
        await getActivitiesAfterResponse(res)
      } else if (route.name !== 'Activities') {
        const { closeDialog } = useDialog()
        closeDialog()
        if (route.name === 'Top') {
          await getTopDataAfterResponse(res)
        } else if (route.name === 'Logs') {
          await getTimelineAfterResponse(res)
        } else if (route.name === 'Notifications') {
          await getNotificationsAfterResponse(res)
        }
      }
      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  const cancelRequest = async (id, type) => {
    try {
      toggleShowLoader(true)
      const res = await axios.post(`/actions/cancel`, {
        document_id: id,
        document_type: type,
      })
      if (route.name === 'Activities') {
        await getActivitiesAfterResponse(res)
      } else if (route.name !== 'Activities') {
        const { closeDialog } = useDialog()
        closeDialog()
        if (route.name === 'Top') {
          await getTopDataAfterResponse(res)
        } else if (route.name === 'Logs') {
          await getTimelineAfterResponse(res)
        } else if (route.name === 'Notifications') {
          await getNotificationsAfterResponse(res)
        }
      }
      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  const approveRequest = async (id, documentId, type, userRank) => {
    try {
      toggleShowLoader(true)
      const { rejectedAttrs, toSnake } = useMemoryReject()
      let data = {}
      // 会派事務局の時にアップデートを行う
      if (userRank === 2) {
        // fileの送信を行うためformDataオブジェクトを使用する
        const formdata = new FormData()
        formdata.append('is_temporary', false)
        formdata.append(
          'document_type',
          currentPoliticalAction.memory.documentType,
        )

        for (
          let i = 0;
          i < currentPoliticalAction.memory.expenses.length;
          i++
        ) {
          // 項目種別のフォームデータを作成
          formdata.append(
            'memory[expenses][' + i + '][type]',
            currentPoliticalAction.memory.expenses[i].type[0].id,
          )

          // 宿泊費の場合、宿泊日数のフォームデータを作成
          if (
            currentPoliticalAction.memory.expenses[i].stayDays &&
            currentPoliticalAction.memory.expenses[i].type[0].id === 1
          ) {
            formdata.append(
              'memory[expenses][' + i + '][stay_days]',
              currentPoliticalAction.memory.expenses[i].stayDays,
            )
          }

          //idのフォームデータを作成
          if (currentPoliticalAction.memory.expenses[i].receipt?.id) {
            formdata.append(
              'memory[expenses][' + i + '][receipt][id]',
              currentPoliticalAction.memory.expenses[i].receipt.id,
            )
          }

          //支払年月日のフォームデータを作成
          formdata.append(
            'memory[expenses][' + i + '][receipt][expense_date]',
            currentPoliticalAction.memory.expenses[i].receipt.expenseDate ===
              null
              ? ''
              : dayjs(
                  currentPoliticalAction.memory.expenses[i].receipt.expenseDate,
                ).format('YYYY-MM-DD'),
          )

          // 経費項目のフォームデータを作成
          if (currentPoliticalAction.actionTypes.length === 1) {
            formdata.append(
              'memory[expenses][' + i + '][receipt][expense_type_id]',
              currentPoliticalAction.actionTypes[0].type,
            )
          }

          // 支払額のフォームデータを作成
          formdata.append(
            'memory[expenses][' + i + '][receipt][expense_amount]',
            currentPoliticalAction.memory.expenses[i].receipt.expenseAmount ===
              null
              ? ''
              : currentPoliticalAction.memory.expenses[i].receipt.expenseAmount,
          )

          // 支出内容のフォームデータを作成
          formdata.append(
            'memory[expenses][' + i + '][receipt][expense_content1]',
            currentPoliticalAction.memory.expenses[i].receipt
              .expenseContent1 === null
              ? ''
              : currentPoliticalAction.memory.expenses[i].receipt
                  .expenseContent1,
          )

          // 補記のフォームデータを作成
          if (
            currentPoliticalAction.memory.expenses[i].receipt.expenseContent2
          ) {
            formdata.append(
              'memory[expenses][' + i + '][receipt][expense_content2]',
              currentPoliticalAction.memory.expenses[i].receipt
                .expenseContent2 === null
                ? ''
                : currentPoliticalAction.memory.expenses[i].receipt
                    .expenseContent2,
            )
          }

          // 債権者住所・氏名のフォームデータを作成
          if (currentPoliticalAction.memory.expenses[i].receipt.creditorInfo) {
            formdata.append(
              'memory[expenses][' + i + '][receipt][creditor_info]',
              currentPoliticalAction.memory.expenses[i].receipt.creditorInfo ===
                null
                ? ''
                : currentPoliticalAction.memory.expenses[i].receipt
                    .creditorInfo,
            )
          }

          // 支払証明書フラグのフォームデータを作成
          formdata.append(
            'memory[expenses][' + i + '][receipt][have_receipt_images]',
            !currentPoliticalAction.memory.expenses[i].receipt
              .haveReceiptImages,
          )

          // 按分フラグのフォームデータを作成
          formdata.append(
            'memory[expenses][' + i + '][receipt][is_distributed]',
            currentPoliticalAction.memory.expenses[i].receipt.isDistributed,
          )

          // 按分分母のフォームデータを作成
          if (
            currentPoliticalAction.memory.expenses[i].receipt.isDistributed &&
            currentPoliticalAction.memory.expenses[i].receipt.numerator
          ) {
            formdata.append(
              'memory[expenses][' + i + '][receipt][numerator]',
              currentPoliticalAction.memory.expenses[i].receipt.numerator,
            )
          }

          //按分分子のフォームデータを作成
          if (
            currentPoliticalAction.memory.expenses[i].receipt.isDistributed &&
            currentPoliticalAction.memory.expenses[i].receipt.denominator
          ) {
            formdata.append(
              'memory[expenses][' + i + '][receipt][denominator]',
              currentPoliticalAction.memory.expenses[i].receipt.denominator,
            )
          }

          // 一部充当金額のフォームデータを作成
          if (
            currentPoliticalAction.memory.expenses[i].receipt.isPartial &&
            currentPoliticalAction.memory.expenses[i].receipt.partialAmount
          ) {
            formdata.append(
              'memory[expenses][' + i + '][receipt][partial_amount]',
              currentPoliticalAction.memory.expenses[i].receipt.partialAmount,
            )
          }
          // 一部充当内容のフォームデータを作成
          if (
            currentPoliticalAction.memory.expenses[i].receipt.isPartial &&
            currentPoliticalAction.memory.expenses[i].receipt.partialComment
          ) {
            formdata.append(
              'memory[expenses][' + i + '][receipt][partial_comment]',
              currentPoliticalAction.memory.expenses[i].receipt.partialComment,
            )
          }

          // 添付資料ののフォームデータを作成
          currentPoliticalAction.memory.expenses[i].additionalResources.forEach(
            file => {
              //登録済みのフォームデータを作成
              if (file?.display) {
                formdata.append(
                  'memory[expenses][' + i + '][keep_file_names][]',
                  file.display,
                )
              } else {
                // 新規登録のフォームデータを作成
                formdata.append(
                  'memory[expenses][' + i + '][additional_resources][]',
                  file,
                )
              }
            },
          )

          //画像のフォームデータを作成
          for (
            let index = 0;
            index < currentPoliticalAction.memory.expenses[i].image.length;
            index++
          ) {
            Object.keys(
              currentPoliticalAction.memory.expenses[i].image[index],
            ).forEach(key => {
              if (currentPoliticalAction.memory.expenses[i].image[index][key]) {
                const keyName =
                  'memory[expenses][' +
                  i +
                  '][images][' +
                  index +
                  '][' +
                  key +
                  ']'
                formdata.append(
                  keyName,
                  currentPoliticalAction.memory.expenses[i].image[index][key],
                )
              }
            })
          }
        }

        // postだとだとマルチパート形式のファイル送信がうまくいかないためputをオーバーライド
        let config = {
          headers: {
            'content-type': 'multipart/form-data',
            'X-HTTP-Method-Override': 'PUT',
          },
        }
        await axios.post(`/actions/${id}`, formdata, config)
      }

      if (rejectedAttrs.length !== 0) {
        toSnake()
        data = {
          document_id: documentId,
          document_type: type,
          sent_back_items: rejectedAttrs,
        }
      } else {
        data = {
          document_id: documentId,
          document_type: type,
        }
      }

      const res = await axios.post(`/actions/approve`, data)
      if (route.name === 'Activities') {
        await getActivitiesAfterResponse(res)
      } else if (route.name !== 'Activities') {
        const { closeDialog } = useDialog()
        closeDialog()
        if (route.name === 'Top') {
          await getTopDataAfterResponse(res)
        } else if (route.name === 'Logs') {
          await getTimelineAfterResponse(res)
        } else if (route.name === 'Notifications') {
          await getNotificationsAfterResponse(res)
        }
      }
      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  return {
    submitActivity,
    cancelRequest,
    approveRequest,
    getSentBackItemMessage,
  }
}
